var pug = require("!../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (Math, count, pageNumber, parseInt, sub_category) {var countInView = Math.min(18, count)
pug_html = pug_html + "\u003Cdiv class=\"container clearfix\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"grid padding-vertical-top-3em\"\u003E\u003Cdiv class=\"col-md-12 text-center\"\u003E";
if ((sub_category.rows.length>0)) {
var currentItemsStart = (pageNumber-1)*18 + 1;
var currentItemsEnd = Math.min(pageNumber*18, count);
pug_html = pug_html + "\u003Ch4 class=\"font-weight-500 margin-0 soft-gray-text\"\u003E" + (pug.escape(null == (pug_interp = currentItemsStart) ? "" : pug_interp)) + "-" + (pug.escape(null == (pug_interp = currentItemsEnd) ? "" : pug_interp)) + " of " + (pug.escape(null == (pug_interp = count) ? "" : pug_interp)) + " craftsmen \u003C\u002Fh4\u003E";
}
else {
pug_html = pug_html + "\u003Ch2\u003EThere are no craftsmen part of this category             \u003C\u002Fh2\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"grid padding-vertical-top-3em\"\u003E";
if ((sub_category.rows.length > 0)) {
// iterate sub_category.rows
;(function(){
  var $$obj = sub_category.rows;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var item = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv class=\"col-xs-6 col-sm-4\"\u003E\u003Cdiv class=\"supplier-grid-item\"\u003E\u003Ca" + (pug.attr("href", "/supplier/" + item.sub_id, true, true)) + "\u003E";
if ((item.food_supplier)) {
pug_html = pug_html + "\u003Cimg" + (" class=\"img-responsive\""+pug.attr("src", item.food_supplier.logo_url ? item.food_supplier.logo_url : "https://via.placeholder.com/400x300/ffe119/000?text=supplier+logo", true, true)) + "\u003E";
}
else {
pug_html = pug_html + "\u003Cimg class=\"img-responsive\" src=\"https:\u002F\u002Fvia.placeholder.com\u002F400x300\u002Fffe119\u002F000?text=supplier+logo\"\u003E";
}
pug_html = pug_html + "\u003Ch4 class=\"font-weight-500\"\u003E" + (pug.escape(null == (pug_interp = item.sub_name) ? "" : pug_interp)) + " \u003C\u002Fh4\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var item = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv class=\"col-xs-6 col-sm-4\"\u003E\u003Cdiv class=\"supplier-grid-item\"\u003E\u003Ca" + (pug.attr("href", "/supplier/" + item.sub_id, true, true)) + "\u003E";
if ((item.food_supplier)) {
pug_html = pug_html + "\u003Cimg" + (" class=\"img-responsive\""+pug.attr("src", item.food_supplier.logo_url ? item.food_supplier.logo_url : "https://via.placeholder.com/400x300/ffe119/000?text=supplier+logo", true, true)) + "\u003E";
}
else {
pug_html = pug_html + "\u003Cimg class=\"img-responsive\" src=\"https:\u002F\u002Fvia.placeholder.com\u002F400x300\u002Fffe119\u002F000?text=supplier+logo\"\u003E";
}
pug_html = pug_html + "\u003Ch4 class=\"font-weight-500\"\u003E" + (pug.escape(null == (pug_interp = item.sub_name) ? "" : pug_interp)) + " \u003C\u002Fh4\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cdiv class=\"clearfix\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"margin-vertical-2em text-center\"\u003E\u003Cdiv class=\"col-md-12\"\u003E";
var totalPages = Math.ceil(count/countInView)
var n = 1;
pug_html = pug_html + "\u003Cscript\u003Ewindow.totalElements = " + (pug.escape(null == (pug_interp = count) ? "" : pug_interp)) + "\u003C\u002Fscript\u003E";
if ((totalPages > 1)) {
pug_html = pug_html + "\u003Cdiv class=\"text-center\"\u003E\u003Cul class=\"pagination pagination-suppliers-category pagination-centered\"\u003E";
while (n <= totalPages) {
pug_html = pug_html + "\u003Cli\u003E\u003Ca" + (pug.attr("href", '?page=' + parseInt(n), true, true)) + "\u003E" + (pug.escape(null == (pug_interp = n++) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Fli\u003E";
}
pug_html = pug_html + "\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"Math" in locals_for_with?locals_for_with.Math:typeof Math!=="undefined"?Math:undefined,"count" in locals_for_with?locals_for_with.count:typeof count!=="undefined"?count:undefined,"pageNumber" in locals_for_with?locals_for_with.pageNumber:typeof pageNumber!=="undefined"?pageNumber:undefined,"parseInt" in locals_for_with?locals_for_with.parseInt:typeof parseInt!=="undefined"?parseInt:undefined,"sub_category" in locals_for_with?locals_for_with.sub_category:typeof sub_category!=="undefined"?sub_category:undefined));;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./~/pug-loader!./views/category/supplier-grid.pug
// module id = 120
// module chunks = 0